import {
  ActiveOrderQueryParams,
  ArchivedOrderQueryParams,
  DetailOrder,
  ListOrder,
  OrdersType,
  SearchOrderQueryParams,
} from "@app/modules/orders/entities/orders.entities";
import { PickingPoint } from "@core/entities";
import { AdapterUi } from "@core/store/adapters/global.adapter";
import { createAction, props } from "@ngrx/store";

export enum OrdersAction {
  ClearAllActiveOrders = "[ACTIVE-ORDERS] Clear all Active orders",
  ClearAllArchivedOrders = "[ACTIVE-ORDERS] Clear all Archived orders",
  UiOrders = "[ACTIVE-ORDERS] Orders UI",
  Empty = "[ACTIVE-ORDERS] Empty",
  FetchOrderId = "[ACTIVE-ORDERS] Fetch Active Order by Id",
  FetchActiveOrderList = "[ACTIVE-ORDERS] Fetch Active Order list",
  FetchArchivedOrderList = "[ACTIVE-ORDERS] Fetch Archived Order list",
  SetOrderSelected = "[ACTIVE-ORDERS] Set Active Order Selected",
  SetActiveOrdersList = "[ACTIVE-ORDERS] Set Active Orders List",
  SetArchivedOrderList = "[ACTIVE-ORDERS] Set Archived Orders List",
  CancelOrder = "[ACTIVE-ORDERS] Cancel order",
  ToggleOrdersType = "[ACTIVE-ORDERS] Toggle between archived and active orders",
  NotifyDeliveredProducts = "[ACTIVE-ORDERS] Notify delivered products to RT",
  FetchPickingPoints = "[ACTIVE-ORDERS] Fetch picking points",
  SetPickingPointsForOrders = "[ACTIVE-ORDERS] Set picking points",
  InputSearch = "[ACTIVE-ORDERS] Search Input",
  ExportOrders = "[ACTIVE-ORDERS] Export Orders",
}

export const uiOrders = createAction(OrdersAction.UiOrders, props<{ ui: Array<AdapterUi> }>());
export const Empty = createAction(OrdersAction.Empty);
export const inputSearch = createAction(OrdersAction.InputSearch, props<SearchOrderQueryParams>());

// active orders
export const clearAllActiveOrders = createAction(OrdersAction.ClearAllActiveOrders);
export const fetchActiveOrderList = createAction(OrdersAction.FetchActiveOrderList, props<ActiveOrderQueryParams>());
export const fetchActiveOrderId = createAction(OrdersAction.FetchOrderId, props<{ payload: number; version: number | null }>());
export const setActiveOrdersList = createAction(OrdersAction.SetActiveOrdersList, props<{ payload: ListOrder[] }>());
export const notifyDeliveredProducts = createAction(OrdersAction.NotifyDeliveredProducts, props<{ rappiId: number; cargoId: string }>());
export const cancelOrder = createAction(
  OrdersAction.CancelOrder,
  props<{ orderId: number; orderVersion: number | null; pickingPointId: number; reason?: string }>()
);

// archived orders
export const clearAllArchivedOrders = createAction(OrdersAction.ClearAllArchivedOrders);
export const fetchArchivedOrderList = createAction(OrdersAction.FetchArchivedOrderList, props<ArchivedOrderQueryParams>());
export const setArchivedOrdersList = createAction(OrdersAction.SetArchivedOrderList, props<{ payload: ListOrder[] }>());

// shared
export const toggleOrdersType = createAction(OrdersAction.ToggleOrdersType, props<{ payload: OrdersType }>());
export const setOrderSelected = createAction(OrdersAction.SetOrderSelected, props<{ payload: DetailOrder }>());
export const setPickingPointsForOrders = createAction(OrdersAction.SetPickingPointsForOrders, props<{ payload: Array<PickingPoint> }>());
export const fetchPickingPoints = createAction(OrdersAction.FetchPickingPoints);
export const exportOrders = createAction(OrdersAction.ExportOrders);
